export var EAnchor;
(function (EAnchor) {
    EAnchor["Top"] = "top";
    EAnchor["Right"] = "right";
    EAnchor["Left"] = "left";
    EAnchor["Bottom"] = "bottom";
})(EAnchor || (EAnchor = {}));
